export const comingSoon = {
	bars: {
		title: "Ajouter des barres",
		message: "Cette fonctionnalité sera bientôt disponible",
	},
	mountableProduct: {
		title: "Produit montable",
		message: "Cette fonctionnalité sera bientôt disponible",
	},
	technicalSheet: {
		title: "Ajouter une fiche technique",
		message: "Cette fonctionnalité sera bientôt disponible",
	},
};
